import angular from 'angular'
import moment from 'moment-timezone'
import './genres.service'
import './channels/channels.controler'
import './orders/orders.controler'

angular
  .module('admin.genres', [
    'admin.genres.service',
    'admin.genres.channels',
    'admin.genres.channel_orders',
  ])
  .controller('GenresCtrl', GenresCtrl)

/** @ngInject */
function GenresCtrl($state, $scope, GenresService, UploadService) {
  var vm = this

  vm.items = []
  vm.perPage = 25
  vm.pathImgThumb = ''
  vm.isOpen = false
  vm.isOpen2 = false

  function reloadPaginationDraft() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublish() {
    vm.totalItems2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalItems3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  reloadPaginationDraft()
  reloadPaginationPublish()
  reloadPaginationArchived()
  loadPublished(1)
  loadUnpublished(1)
  loadArchived(1)

  var tab = localStorage.getItem('genres_tab')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#archived').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else if (tab === 'published') {
      $('#draft').removeClass('active')
      $('#archived').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    } else if (tab === 'expired') {
      $('#draft').removeClass('active')
      $('#published').removeClass('active')
      $('#expired').addClass('active')
      $('#expiredtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }

  vm.tabDraft = function () {
    $('#published').removeClass('active')
    $('#expired').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('genres_tab', 'draft')
  }

  vm.tabPublished = function () {
    $('#draft').removeClass('active')
    $('#expired').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('genres_tab', 'published')
  }

  vm.tabExpired = function () {
    $('#draft').removeClass('active')
    $('#published').removeClass('active')
    $('#expired').addClass('active')
    localStorage.setItem('genres_tab', 'expired')
  }

  function loadUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    GenresService.listUnpublish(vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
        if (pageNumber === 1 && i === 0) {
          result.results[i].firstRow = true
        }

        if (result.results.length - 1 === i && result.results.length < vm.currentPage) {
          result.results[i].lastRow = true
        }
      }
      vm.items = result.results
    })
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    GenresService.listPublish(vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }

        if (pageNumber === 1 && i === 0) {
          result.results[i].firstRow = true
        }

        if (result.results.length - 1 === i && result.results.length < vm.currentPage2) {
          result.results[i].lastRow = true
        }
      }
      vm.itemsPublish = result.results
    })
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage2 - 25
    } else {
      vm.first3 = false
    }

    GenresService.listArchived(vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
        if (pageNumber === 1 && i === 0) {
          result.results[i].firstRow = true
        }

        if (result.results.length - 1 === i && result.results.length < vm.currentPage3) {
          result.results[i].lastRow = true
        }
      }
      vm.itemsArchived = result.results
    })
  }

  vm.load = function () {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    loadUnpublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged2 = function (newPage) {
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged3 = function (newPage) {
    vm.sortType3 = oldSortType3
    loadArchived(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = function () {
    vm.app = {
      id: 0,
      'img-t': '',
      t: '',
      txt: '',
      n: 0,
    }
    vm.data1 = null
    vm.data2 = null
    $('#myModalAdd').modal('show')
  }

  vm.edit = function (item) {
    vm.app = angular.copy(item)
    delete vm.app.ts
    delete vm.app['ts-m']

    if (vm.app['ts-start']) {
      vm.app['ts-start'] = vm.app['ts-start'] / 1000
      vm.app['ts-start'] = new Date(parseInt(vm.app['ts-start']))
      vm.data1 = angular.copy(vm.app['ts-start'])
    } else {
      vm.data1 = null
    }

    if (vm.app['ts-end']) {
      vm.app['ts-end'] = vm.app['ts-end'] / 1000
      vm.app['ts-end'] = new Date(parseInt(vm.app['ts-end']))
      vm.data2 = angular.copy(vm.app['ts-end'])
    } else {
      vm.data2 = null
    }
    $('#myModalAdd').modal('show')
  }

  vm.create = function () {
    if (!vm.app.t) {
      swal('Please enter a Title', '', 'error')
      return
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        vm.app['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      vm.app['ts-start'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        vm.app['ts-end'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      vm.app['ts-end'] = null
    }

    GenresService.save(vm.app).then(
      function () {
        $('#myModalAdd').modal('hide')
        loadUnpublished(1)
        loadPublished(1)
        loadArchived(1)
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.update = function () {
    if (!vm.app.t) {
      swal('Please enter a Title', '', 'error')
      return
    }

    vm.app.n = parseInt(vm.app.n)

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        vm.app['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      vm.app['ts-start'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        vm.app['ts-end'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      vm.app['ts-end'] = null
    }

    GenresService.update(vm.app.id, vm.app).then(
      function () {
        $('#myModalAdd').modal('hide')
        loadUnpublished(1)
        loadPublished(1)
        loadArchived(1)
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          GenresService.remove(item.id).then(
            function () {
              $('#myModalAdd').modal('hide')
              loadUnpublished(1)
              loadPublished(1)
              loadArchived(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.uploadThumb = function (item) {
    if (vm.pathImgThumb.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    let newId = Math.floor(Math.random() * 1000000)
    if (item.id) {
      newId = item.id
    }

    vm.loadThumb = true
    UploadService.save('genres', vm.pathImgThumb, 'img-t', newId).then(function (fileName) {
      vm.loadThumb = false
      item['img-t'] = fileName
    })
  }

  vm.channels = function (item) {
    $state.go('admin.genres.channels', { id: item.id })
  }

  vm.orders = function (item) {
    $state.go('admin.genres.orders', { id: item.id })
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.arrowUp = function (item) {
    if (item.edit) {
      return
    }
    var copy = angular.copy(item)
    copy.n = copy.n - 1
    GenresService.update(item.id, {
      n: copy.n,
    }).then(function () {
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination2.current)
      loadArchived(vm.pagination3.current)
    })
  }

  vm.arrowDown = function (item) {
    if (item.edit) {
      return
    }
    var copy = angular.copy(item)
    copy.n = copy.n + 1
    GenresService.update(item.id, {
      n: copy.n,
    }).then(function () {
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination2.current)
      loadArchived(vm.pagination3.current)
    })
  }
}
